// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../types";

import { createValidator } from "#stdnum-runtime";

const iban: GlobalValidator = createValidator("iban", 92);

export default iban;
export const compact = iban.compact;
export const format = iban.format;
export const validate = iban.validate;
export const generate = (): string =>
  iban.generate?.() ??
  (() => {
    throw new Error(
      "Validator iban cannot generate values",
    );
  })();
